import { Box, Skeleton, Stack, Typography } from '@mui/material';

interface SummaryToolTipContentProps {
  isLoading?: boolean;
  summary?: string;
}

const SummaryToolTipContent = ({ isLoading, summary }: SummaryToolTipContentProps) =>
  isLoading ? (
    <Stack gap={'6px'}>
      <Skeleton width={140} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
      <Skeleton width={200} height={20} variant="rounded" />
    </Stack>
  ) : (
    <Box>
      <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>Overview</Typography>
      <Typography sx={{ fontSize: '11px', fontWeight: 500, whiteSpace: 'pre-line' }}>
        {summary}
      </Typography>
    </Box>
  );

export default SummaryToolTipContent;
